import { preparePhone } from '@/helpers/functions'
import Repository from './Repository'

export default {
  bidView() {
    const action = '/trash/bid-view'

    return Repository.post(action, { bid_id: 1607 })
  },

  clickBid(id) {
    const action = '/trash/bid-click'

    return Repository.post(action, { bid_id: id })
  },
  // этот метод возвращает 500, нужно регистрироваться через метод login
  register(login, type, code) {
    const action = '/register'

    login = preparePhone(login)

    return Repository.post(action, { login, type, code })
  },
  getcode(login, fio = '') {
    const action = '/get-code'

    const requestData = {
      phone: preparePhone(login),
    }

    if (fio) {
      requestData.fio = fio
    }

    return Repository.post(action, requestData)
  },
  getCodeLandingPage(login, fio = '') {
    const action = '/auth/landing-code'

    const requestData = {
      phone: preparePhone(login),
    }

    if (fio) {
      requestData.fio = fio
    }

    return Repository.post(action, requestData)
  },
  getChekCodeLandingPage({ phone, ...data }) {
    const action = '/auth/landing-combo-auth'

    return Repository.post(action, { phone: preparePhone(phone), ...data })
  },
  login(login, code) {
    const action = '/login'

    login = preparePhone(login)

    return Repository.post(action, { login, code })
  },
}
